// Attempts to open the mobile app via its custom URL scheme
// (stagedriving://<path> - registered on both platforms, see
// mobile/ios/stagedriving/Info.plist's CFBundleURLSchemes and
// mobile/android/app/src/main/AndroidManifest.xml's stagedriving
// intent-filter). If the OS doesn't hand off to an installed app within
// a short window - detected via the page going hidden, the same
// visibilitychange-based technique "open in app" banners use - falls
// back to the given callback instead, so behavior when the app isn't
// installed (or on desktop) is unchanged from a direct redirect.
export function openAppOrRedirect(deepLinkPath, onFallback) {
    const deepLinkUrl = `stagedriving://${deepLinkPath}`;
    let didHide = false;

    const onVisibilityChange = () => {
        if (document.hidden) {
            didHide = true;
        }
    };
    document.addEventListener('visibilitychange', onVisibilityChange);

    window.location.href = deepLinkUrl;

    setTimeout(() => {
        document.removeEventListener('visibilitychange', onVisibilityChange);
        if (!didHide) {
            onFallback();
        }
    }, 1500);
}
